<template>
  <v-layout row wrap mb-4 pa-4>
    <!-- old
    <case-header></case-header>
    -->
    <case-header-new></case-header-new>
    <v-flex xs12>
    <CaseTasklistContainer :the-case="theCase"></CaseTasklistContainer>
      <v-layout xs12 fluid row wrap>
        <v-flex xs12>
        <v-divider class="xs12  mt-3"></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-btn class="mt-4 mb-0 mx-0" color="success" style="float:right">Save changes</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import CaseHeader from "@/components/cases/case-edit/CaseHeader"
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew"
import CaseTasklistContainer from "@/components/cases/case-edit/CaseTasklistContainer"
import { mapState } from 'vuex'

export default {
  name: "case-tasks",
  data: () => ({
    dialogDelete: false
  }),
  computed: {
    ...mapState({ theCase: state => state.cases.currentlySelected.case })
  },
  components: { CaseHeader, CaseTasklistContainer, CaseHeaderNew },
  beforeRouteLeave(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("unsubscribeToCaseChannelV2", { caseId: from.params.case_id, currentUser: currentUser })
    next()
  },
  beforeRouteEnter(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("subscribeToCaseChannelV2", { caseId: to.params.case_id, currentUser })
    next()
  }
}
</script>


